import { type CSSProperties, type PropsWithChildren } from 'react';

import HeaderSetter from '@/hooks/header/HeaderSetter';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  title?: string;
  pageName?: string;
  exampleAIQuestions: string[];
  style?: CSSProperties;
  noPadding?: boolean;
};

const Page = ({
  className = '',
  title,
  pageName,
  exampleAIQuestions,
  children,
  style = {},
  noPadding = false,
  ...rest
}: PropsWithChildren<Props>) => (
  <div
    id="pageRoot"
    {...rest}
    className={cn('relative flex flex-1 flex-col', noPadding ? 'p-0' : 'px-8 py-6', className)}
    style={style}
  >
    {title && (
      <HeaderSetter exampleAIQuestions={exampleAIQuestions ?? []}>
        {`${title}${pageName != null ? ` - ${pageName}` : ''}`}
      </HeaderSetter>
    )}
    {children}
  </div>
);

export default Page;
